<!-- 浙江绿色工程 申请明细列表 -->
<template>
   <div>
      <!--搜索栏-->
      <div class="contribute stageShow" v-show="showStage">
         <div :class="getStageClass('项目申报阶段')">
            项目申报阶段
         </div>
         <div :class="getStageClass('地基与基础阶段')">
            地基与基础阶段
         </div>
         <div :class="getStageClass('主体结构阶段')">
            主体结构阶段
         </div>
         <div :class="getStageClass('装饰装修与机电安装阶段')">
            装饰装修与机电安装阶段
         </div>
         <div :class="getStageClass('竣工验收阶段')">
            竣工验收阶段
         </div>
         <div :class="getStageClass('证书制作阶段')">
            证书制作阶段
         </div>
      </div>
      <div class="contribute" v-show="false">
         <div class="inner_view">
            <div class="spanClass">
               <span style="line-height: 32px">项目名称:</span>
               <el-input v-model="filter.prjName" placeholder="请输入项目名称"
                         :clearable="true" style="margin-left: 10px;width: 200px;"></el-input>
            </div>
         </div>
         <div>
            <el-button type="primary" style="margin-left: 20px" @click="searchData">
               查询
            </el-button>
         </div>
      </div>
      <!--表格数据展示-->
      <div class="contribute tableContainer">
         <el-table :data="table.data" border ref="mainTable" row-key="rowID" v-loading="table.showLoading">
            <el-table-column type="index" :index="indexNo" label="序号" width="50" fixed="left"></el-table-column>
            <div v-for="(item,index) in table.column" :key="index">
               <el-table-column :prop="item.prop" :label="item.label"></el-table-column>
            </div>
            <el-table-column fixed="right" label="操作">
               <template v-slot="scope">
                  <el-button type="text" size="small" v-if="[1,2,7,8,9,11,13].includes(scope.row.status)"
                             @click="rowDetail(scope.row)">
                     查看
                  </el-button>
                  <el-button type="text" v-if="[0,8,16].includes(scope.row.status)" size="small"
                             @click="rowUpdate(scope.row)">
                     编辑
                  </el-button>
                  <el-button type="text" v-show="false" v-if="[0].includes(scope.row.status)" size="small"
                             @click="rowDelete(scope.row)">
                     删除
                  </el-button>
                  <el-button type="text" v-if="[0,8].includes(scope.row.status)" size="small"
                             @click="rowSubmit(scope.row)">
                     提交
                  </el-button>
               </template>
            </el-table-column>
         </el-table>
      </div>
      <!--分页栏-->
      <div style="margin-top: 50px;" v-if="pager.rowCount>10">
         <el-pagination background :layout="pager.layout" :current-page="pager.pageIndex" :page-size="pager.pageSize"
                        :total="pager.rowCount" @size-change="pageSizeChange"
                        @current-change="pageIndexChange"></el-pagination>
      </div>
      <!--要展示的对话框-->
      <div class="dialog">
         <submit-dialog ref="submitDialog" @dialogClose="this.searchData"></submit-dialog>
      </div>
   </div>
</template>

<script>
import {getApplyList_Apply} from '@/api/modules/greenEngineerApply.js'
import {applyDelete, getPrjStageInfo} from '@/api/modules/project'
import submitDialog from "@/views/greenEngineerApply/components/submitDialog";

export default {
   data() {
      return {
         filter: {},
         pager: {
            layout: 'total, sizes, prev, pager, next, jumper',
            pageIndex: 1,
            pageSize: 10,
            rowCount: 0,
         },
         table: {
            data: [],
            //表格列配置
            column: [{'prop': 'engineering_name', 'label': '工程名称'},
               {'prop': 'recoCompanyName', 'label': '推荐单位'},
               {'prop': 'stageName', 'label': '申报阶段'},
               {'prop': 'stageStatusShow', 'label': '状态'},
               {'prop': 'stageCreate', 'label': '生成时间'},
               {'prop': 'stageSubmit', 'label': '提交时间'},
               {'prop': 'stageAudit', 'label': '审核时间'},
               {'prop': 'stageAdvise', 'label': '审核意见'},],
            showLoading: false
         },
         ddl: {
            //处理状态
            statusList: [{'text': '未提交', 'value': '0'}, {'text': '已提交', 'value': '1'}]
         },
         /*是否显示阶段流程*/
         showStage: false,
         /*阶段数组*/
         stageArray: ['项目申报阶段', '地基与基础阶段', '主体结构阶段', '装饰装修与机电安装阶段', '竣工验收阶段', '证书制作阶段'],
         /*阶段列表*/
         stageList: null,
         /*当前阶段*/
         curStage: null,
      }
   },
   components: {
      submitDialog
   },
   created() {
      this.searchData()
   },
   computed: {
      //计算行号
      indexNo() {
         return this.pager.pageSize * (this.pager.pageIndex - 1) + 1
      },
   },
   methods: {
      /*返回阶段样式*/
      getStageClass(stageName) {
         const index = this.stageArray.indexOf(stageName);
         const curIndex = this.stageArray.indexOf(this.curStage.stage);
         if (index < curIndex)
            return 'end';
         if (index > curIndex)
            return 'wait';
         if (index == curIndex)
            return 'start';
      },
      /*申请查看*/
      async rowDetail(row) {
         localStorage.setItem("opMode", "detail");
         localStorage.setItem("isInsert", "false")
         this.$router.push({
            path: '/index/greenEngineerApply/apply',
            query: {prjApplyCode: row.project_application_id}
         });
      },
      /*申报修改*/
      async rowUpdate(row) {
         localStorage.setItem("opMode", "edit");
         localStorage.setItem("isInsert", "false")
         this.$router.push({
            path: '/index/greenEngineerApply/apply',
            query: {prjApplyCode: row.project_application_id}
         })
      },
      /*申报删除*/
      async rowDelete(row) {
         this.$confirm('确认删除?').then(() => {
            applyDelete({
               data: {prjApplyId: row.project_application_id},
               success: (res) => {
                  this.$message.success("删除成功");
                  this.searchData();
               }
            });
         })
      },
      /*申请提交*/
      async rowSubmit(row) {
         this.$refs.submitDialog.showDialog(row.project_application_id);
      },
      /*获取数据*/
      async searchData() {
         const params = {
            ...this.filter,
            //申报单位编号 获取该单位申报的项目
            company_code: localStorage.getItem('company_code'),
            createdBy: localStorage.getItem('userCode'),
            pageIndex: this.pager.pageIndex,
            pageSize: this.pager.pageSize
         }
         console.info(params);
         this.loading = true
         await getApplyList_Apply({
            data: params,
            success: (res) => {
               this.table.data = res.data.list;
               this.pager.rowCount = res.data.pageInfo.rowCount
               this.loading = false

               /* 当有数据的时候，获取项目编号，用项目编号获取项目的阶段信息 */
               if (this.table.data.length > 0) {
                  const prjApplyId = this.table.data[0]['project_application_id'];
                  //获取项目的阶段信息
                  getPrjStageInfo({
                     data: {prjApplyId: prjApplyId},
                     success: res => {
                        console.info(res);
                        this.stageList = res.data.list;
                        this.curStage = res.data.stage;
                        this.showStage = true;
                        /* 保存当前阶段和阶段状态 */
                        localStorage.setItem('stage', this.curStage.stage);
                        localStorage.setItem('stageStatus', this.curStage.status);
                     }
                  })
               }
            }
         })
      },
      //换页切换
      pageIndexChange(val) {
         this.pager.pageIndex = val
         this.searchData()
      },
      //分页数量切换
      pageSizeChange(val) {
         this.pager.pageSize = val
         this.searchData()
      },
      //显示模态对话框
      showDialog(type, row) {
         this.$refs[type].showDialog(row);
      },
   }
}
</script>

<style scoped="scoped">

.stageShow {
   padding-left: 20px;
   padding-right: 20px;
}

.stageShow div {
   border: 1px solid black;
   padding: 15px;
   border-radius: 10px;
}

.stageShow .wait {
   background-color: gray;
   color: white;
}

.stageShow .start {
   background-color: blue;
   color: white;
}

.stageShow .end {
   background-color: green;
   color: white;
}


.tableContainer {
   width: 100%;
   min-height: 90px;
   height: auto;
   background-color: #f9f9f9;
}

.tableContainer thead th {
   background-color: #dce0e6 !important;
   font-weight: bold;
   font-size: 15px;
   width: calc(100% - 2px);
}

.contribute {
   display: flex;
   margin: 20px 0;
   display: flex;
   align-items: center;
   justify-content: space-between;
   min-height: 40px;
}

.inner_view {
   line-height: 50px;
   display: flex;
   align-items: center;
   flex-wrap: wrap;
   align-content: space-around;
   justify-content: flex-start;
}

.spanClass {
   line-height: 32px;
   margin-left: 20px;
}

</style>
